/**
 * @file Loading
 * @author Ice(chenzhouji@baidu.com)
 * @modify zhangzhe(zhangzhe@baidu.com)
 * @modify xuemin02(xuemin02@baidu.com)
 */

import React, {useState, useRef, useEffect} from 'react';
import {findDOMNode} from 'react-dom';
import {Loading} from 'acud';

import {DU_PREFIX} from '../../_common/constants';
import './index.less';

import {useLocale} from '../../locale';

const CLS_PREFIX = `${DU_PREFIX}-loading`;

export interface LoadingProps {
    text?: string;
}

export default (props: LoadingProps) => {
    const [locale] = useLocale('Loading');
    const {text = locale?.loading} = props;

    const [height, setHeight]: [string | number, any] = useState('100%');
    const loadingRef: any  = useRef(null);

    useEffect(() => {
        const currentDom = findDOMNode(loadingRef.current) as HTMLElement;
        const parentNode = currentDom.parentNode as HTMLElement;
        const newHeight = parentNode ? parentNode.offsetHeight - 20 : height;
        setHeight(newHeight);
    }, []);

    return (
        <div className={CLS_PREFIX} style={{height}} ref={loadingRef}>
            <Loading loading tip={text} />
        </div>
    );
};
